module.exports = __webpack_public_path__ + "e6075cd147ddd50149c8b30da3b59729.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/train/view/home/images/4.png
// module id = 180
// module chunks = 1